import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout'
import Seo from '../components/seo'
import Hero from '../components/Hero'
import Home from '../components/Home'

const IndexPage = ({ data }) => {
  const { contentfulPage, allContentfulPost } = data
  const { hero, blogs, videos } = contentfulPage
  const { coverImage, headLine } = hero
  const { edges: profiles } = allContentfulPost
  return (
    <Layout>
      <Seo title='Home' description={headLine} />
      <Hero title={headLine} image={coverImage} auto={false} />
      <Home.Menu />
      <Home.Videos videos={videos} />
      {profiles.length > 0 && <Home.Profiles profiles={profiles} />}
      <Home.Blogs blogs={blogs} />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape()
}

IndexPage.defaultProps = {
  data: {}
}

export default IndexPage

export const PageQuery = graphql`
  query HomePage {
    contentfulPage(typePage: {eq: "home"})  {
      hero {
        headLine
        coverImage {
          file {
            fileName
            url
          }
        }
      }
      blogs {
        slug
        title
        createdAt(formatString: "MMM DD, YYYY")
        author {
          name
        }
        image {
          file {
            url
            fileName
          }
        }
        bodyContent {
          childMarkdownRemark {
            html
          }
        }
      }
      videos {
        slug
        title
        image {
          file {
            url
            fileName
          }
        }
        bodyContent {
          childMarkdownRemark {
            html
          }
        }
      }
    }

    allContentfulPost(filter: {type: {eq: "community"}}) {
      edges {
        node {
          slug,
          title
          headLine
          avatar {
            file {
              url
              fileName
            }
          }
        }
      }
    }
  }
`
